export const API_REQUEST = "API_REQUEST"
export const API_POST_SUCCESS = "API_POST_SUCCESS"
export const API_GET_SUCCESS = "API_GET_SUCCESS"
export const API_GET_MY_SUCCESS = "API_GET_MY_SUCCESS"
export const API_DELETE_MY_SUCCESS = "API_API_DELETE_MY_SUCCESS"
export const API_EDIT_MY_SUCCESS = "API_API_EDIT_MY_SUCCESS"
export const API_FAILED = "API_FAILED"